import { watch } from "vue";

function getStorage() {
  if (typeof window === "undefined") return null;

  try {
    return window.localStorage;
  } catch (error) {
    console.warn("No se pudo acceder a localStorage:", error);
    return null;
  }
}

export function useFormDraft({
  key,
  form,
  currentStep,
  version = 1,
  maxStep,
}) {
  const storage = getStorage();
  let persistenceEnabled = true;

  function removeStoredDraft() {
    if (!storage) return;

    try {
      storage.removeItem(key);
    } catch (error) {
      console.warn(`No se pudo eliminar el borrador ${key}:`, error);
    }
  }

  function restoreDraft() {
    if (!storage) return false;

    try {
      const serializedDraft = storage.getItem(key);
      if (!serializedDraft) return false;

      const draft = JSON.parse(serializedDraft);
      if (
        draft?.version !== version ||
        !draft.form ||
        typeof draft.form !== "object"
      ) {
        removeStoredDraft();
        return false;
      }

      const restoredForm = Object.keys(form).reduce((result, field) => {
        if (Object.prototype.hasOwnProperty.call(draft.form, field)) {
          result[field] = draft.form[field];
        }
        return result;
      }, {});

      Object.assign(form, restoredForm);

      const restoredStep = Number(draft.currentStep);
      if (Number.isInteger(restoredStep)) {
        currentStep.value = Math.min(Math.max(restoredStep, 1), maxStep);
      }

      return true;
    } catch (error) {
      console.warn(`No se pudo restaurar el borrador ${key}:`, error);
      removeStoredDraft();
      return false;
    }
  }

  function saveDraft() {
    if (!storage || !persistenceEnabled) return;

    try {
      const formSnapshot = Object.keys(form).reduce((result, field) => {
        result[field] = form[field];
        return result;
      }, {});

      storage.setItem(
        key,
        JSON.stringify({
          version,
          savedAt: new Date().toISOString(),
          currentStep: currentStep.value,
          form: formSnapshot,
        }),
      );
    } catch (error) {
      console.warn(`No se pudo guardar el borrador ${key}:`, error);
    }
  }

  function completeDraft() {
    persistenceEnabled = false;
    removeStoredDraft();
  }

  function startNewDraft() {
    persistenceEnabled = true;
    removeStoredDraft();
    saveDraft();
  }

  const wasDraftRestored = restoreDraft();

  watch([() => form, currentStep], saveDraft, {
    deep: true,
    flush: "post",
  });

  return {
    wasDraftRestored,
    completeDraft,
    startNewDraft,
  };
}
